export default __webpack_public_path__ + "static/media/top-tree.9aac7bfc.webp";